

<mat-form-field class="full-width">
  
  <input [readonly]="batchReadonlyObs | async" #inputRef matInput [matAutocomplete]="autocompleteRef" [value]="signatureTask.batchName"/>
  <mat-label>{{'ss-entities.task.batch-name' | translate}}</mat-label>
  <mat-autocomplete #autocompleteRef>
    <mat-option *ngFor="let batchName of (activityBatchesObs | async)" [value]="batchName">{{batchName}}</mat-option>
  </mat-autocomplete>
  
  <button *ngIf="!(batchReadonlyObs | async)" (click)="clear($event)" mat-icon-button matSuffix><mat-icon>close</mat-icon></button>

</mat-form-field>
